import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { LanguageContext, getTranslation } from '../LanguageContext';
import { FaVideo, FaArrowLeft, FaSpinner, FaPlay, FaFilm } from 'react-icons/fa';
import './VideosPage.css';

const videosTranslations = {
  en: {
    title: "Videos",
    subtitle: "Browse our video library",
    loading: "Loading videos...",
    noVideos: "No video albums available yet",
    videos: "videos",
    viewAlbum: "View Album",
    back: "Back",
    allAlbums: "All Video Albums"
  },
  fr: {
    title: "Vidéos",
    subtitle: "Parcourez notre vidéothèque",
    loading: "Chargement des vidéos...",
    noVideos: "Aucun album vidéo disponible pour le moment",
    videos: "vidéos",
    viewAlbum: "Voir l'album",
    back: "Retour",
    allAlbums: "Tous les albums vidéo"
  },
  ar: {
    title: "الفيديوهات",
    subtitle: "تصفح مكتبة الفيديو الخاصة بنا",
    loading: "جاري تحميل الفيديوهات...",
    noVideos: "لا توجد ألبومات فيديو متاحة حالياً",
    videos: "فيديوهات",
    viewAlbum: "عرض الألبوم",
    back: "العودة",
    allAlbums: "جميع ألبومات الفيديو"
  }
};

const VideosPage = () => {
  const [videoAlbums, setVideoAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const { language } = useContext(LanguageContext);
  const translate = (key) => getTranslation(videosTranslations, language, key);
  const isRTL = language === 'ar';

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        const res = await axios.get('http://localhost:4444/videos');
        setVideoAlbums(res.data.data || []);
      } catch (error) {
        console.error('Error fetching video albums:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, []);

  if (loading) {
    return (
      <div className="videos-page">
        <div className="videos-page-loading">
          <FaSpinner className="spin" />
          <p>{translate('loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`videos-page ${isRTL ? 'rtl' : ''}`}>
      <div className="videos-page-hero">
        <div className="videos-page-hero-overlay"></div>
        <div className="videos-page-hero-content">
          <div className="videos-page-hero-nav">
            <Link to="/" className="videos-page-back-btn">
              <FaArrowLeft />
              <span>{translate('back')}</span>
            </Link>
          </div>
          <div className="videos-page-hero-icon">
            <FaPlay />
          </div>
          <h1>{translate('title')}</h1>
          <p>{translate('subtitle')}</p>
        </div>
      </div>

      <div className="videos-page-content">
        <div className="videos-page-section-header">
          <h2>
            <FaFilm />
            {translate('allAlbums')}
          </h2>
          <span className="videos-page-count">{videoAlbums.length}</span>
        </div>

        {videoAlbums.length === 0 ? (
          <div className="videos-page-empty">
            <FaVideo className="empty-icon" />
            <p>{translate('noVideos')}</p>
          </div>
        ) : (
          <div className="videos-page-grid">
            {videoAlbums.map((album) => (
              <Link to={`/videos/${album._id}`} key={album._id} className="videos-page-card">
                <div className="videos-page-card-image">
                  {album.Videos && album.Videos.length > 0 && album.Videos[0].URLImage ? (
                    <img src={album.Videos[0].URLImage} alt={album.title} loading="lazy" />
                  ) : (
                    <div className="videos-page-card-placeholder">
                      <FaVideo />
                    </div>
                  )}
                  <div className="videos-page-card-play">
                    <FaPlay />
                  </div>
                  <div className="videos-page-card-badge">
                    <FaVideo />
                    <span>{album.Videos?.length || 0} {translate('videos')}</span>
                  </div>
                </div>
                <div className="videos-page-card-body">
                  <h3>{album.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VideosPage;
